export * from './baseThemes/index.js';
export * from './fonts.js';
export const BRAND_COLOR_KEYS = [
    'primary',
    'accessibleOverPrimary',
    'accessibleOverBackground',
];
export const BACKGROUND_COLOR_KEYS = [
    'primary',
    'secondary',
    'divider',
    'opacity',
];
export const TEXT_COLOR_KEYS = ['primary', 'secondary', 'placeholder'];
export const THEME_NAMES = ['opal'];
export const BRIGHTNESS_PALETTES = ['light', 'dark'];
export const UX_COLOR_SYSTEMS = [
    'success',
    'warning',
    'danger',
    'info',
];
export const BASIC_COLOR_TYPES = ['red', 'orange', 'green', 'blue'];
export const FULL_COLOR_TYPES = ['neutral'];
export const BASIC_PALETTE_KEYS = [100, 200, 300, 400];
export const FULL_PALETTE_KEYS = [
    ...BASIC_PALETTE_KEYS,
    500,
    600,
    700,
    800,
];
export const PALETTE_KEYS = BASIC_COLOR_TYPES.reduce((topAcc, color) => [
    ...topAcc,
    ...BASIC_PALETTE_KEYS.reduce((acc, key) => [...acc, `${color}.${key}`], []),
], []);
export const FONTS = [
    'Abril Fatface',
    'Cabin',
    'Poppins',
    'DM Sans',
    'Manrope',
    'Playfair Display',
    'IBM Plex Sans',
    'Oswald',
    'Cardo',
    'Syne',
    'Nunito',
    'Noto Serif Display',
    'Raleway',
    'Inter',
];
export const PAIRINGS = [
    'chic',
    'geometric',
    'modern',
    'elegant',
    'urban',
    'super',
    'luxury',
];
//# sourceMappingURL=index.js.map